import { AlertBlockWarning } from '@klarna/bubble-ui';
import { selectors as experimentationSelectors } from '@merchant-portal/experimentation';
import { hooks as i18nHooks } from 'mage-i18n';
import { TrackImpression } from 'mage-insights';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useAccess } from '../../hooks/useAccess';
import { useApiKey } from '../../hooks/useApiKey';
import { useMid } from '../../hooks/useMid';
import { usePlugin } from '../../hooks/usePlugin';
const TRANSLATION_PREFIX = 'home-fe.boosters-plugin.instructions.api-key';
const MANAGE_API_KEYS_PATH = '/settings/api-credentials';
const MANAGE_API_KEYS_PATH_NEW = '/settings/api-keys';
const API_KEYS_PAGE_EXPERIMENT_KEY = 'merchant-portal.settings.api-keys-page.enabled';
const Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-admiph" }) `
  width: 100%;
`;
export default function ApiKeyBanner() {
    const t = i18nHooks.useTranslator();
    const { canCreateApiKey } = useAccess();
    const { hasAlreadyActiveKeys } = useApiKey();
    const { pluginId } = usePlugin();
    const { selectedMid } = useMid();
    const isApiKeysPageEnabled = useSelector(experimentationSelectors.isFeatureToggleEnabled(API_KEYS_PAGE_EXPERIMENT_KEY));
    const navigateToSettings = useCallback(() => {
        window.location.href = isApiKeysPageEnabled ? MANAGE_API_KEYS_PATH_NEW : MANAGE_API_KEYS_PATH;
    }, [isApiKeysPageEnabled]);
    const event = {
        category: `boost-home/plugin-guide/${pluginId}/active-api-key-warning`,
        action: 'impression',
        label: selectedMid !== null && selectedMid !== void 0 ? selectedMid : undefined
    };
    const mustDisplayBanner = canCreateApiKey && hasAlreadyActiveKeys;
    if (!mustDisplayBanner) {
        return null;
    }
    let alertContentTranslationPath = 'active-warning.content';
    let alertLinkLabelTranslationPath = 'active-warning.link';
    if (isApiKeysPageEnabled) {
        alertContentTranslationPath = 'active-warning-api-keys.content';
        alertLinkLabelTranslationPath = 'active-warning-api-keys.link';
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TrackImpression, { event: event },
            React.createElement(Container, null,
                React.createElement(AlertBlockWarning, { content: [t(`${TRANSLATION_PREFIX}.${alertContentTranslationPath}`)], linkLabel: t(`${TRANSLATION_PREFIX}.${alertLinkLabelTranslationPath}`), onLinkClick: navigateToSettings })))));
}
